module.exports = __webpack_public_path__ + "assets/img/logo_icon.48450fb6.png";